export * from './constants';
export * from './types';
export * from './storage';
export * from './logRocket';

import i18n from '@/i18n/i18n';

/** Consent UI copy — resolved through i18next (`consent` namespace). */
export const consentCopy = {
  get bannerTitle() {
    return i18n.t('consent:bannerTitle');
  },
  get bannerDescription() {
    return i18n.t('consent:bannerDescription');
  },
  get acceptAll() {
    return i18n.t('consent:acceptAll');
  },
  get rejectNonEssential() {
    return i18n.t('consent:rejectNonEssential');
  },
  get managePreferences() {
    return i18n.t('consent:managePreferences');
  },
  get preferencesTitle() {
    return i18n.t('consent:preferencesTitle');
  },
  get preferencesDescription() {
    return i18n.t('consent:preferencesDescription');
  },
  get necessaryTitle() {
    return i18n.t('consent:necessaryTitle');
  },
  get necessaryDescription() {
    return i18n.t('consent:necessaryDescription');
  },
  get functionalTitle() {
    return i18n.t('consent:functionalTitle');
  },
  get functionalDescription() {
    return i18n.t('consent:functionalDescription');
  },
  get analyticsTitle() {
    return i18n.t('consent:analyticsTitle');
  },
  get analyticsDescription() {
    return i18n.t('consent:analyticsDescription');
  },
  get savePreferences() {
    return i18n.t('consent:savePreferences');
  },
  get cookiePreferencesLink() {
    return i18n.t('consent:cookiePreferencesLink');
  },
  get privacyPolicy() {
    return i18n.t('consent:privacyPolicy');
  },
  get terms() {
    return i18n.t('consent:terms');
  },
  get refundPolicy() {
    return i18n.t('consent:refundPolicy');
  }
} as const;
